import Cookies from "js-cookie";
import * as types from "../mutation-types";
import Storage from "@/utils/storage";
import Api from "@/api";
import device from "@/utils/device";
const setToken = (token) => {
  if (!token) {
    return removeToken();
  }
  sessionStorage.setItem("token", token);
  Cookies.set("token", token, 30);
  Storage.set("token", token, 30);
};

const removeToken = () => {
  sessionStorage.removeItem("token");
  Cookies.remove("token");
  Storage.remove("token");
};

const screenWidth = window.screen.width;
const isPc = screenWidth > 900 ? true : false;
const state = {
  userInfo: {},
  loggedIn: false,
  accessToken: "",
  dict: {},
  webConfig: {},
  shareInfo: {},
  open: true,
  pcMode: isPc,
  substation: Number(Storage.get("_substation")) || null, // 分站 多端统一
  included: ["Home"],
  redirectUrl: "",
  userType: null,
  companyInfo: {},
  captchaConfig: {},
};

const getters = {
  userInfo: (state) => state.userInfo,
  loggedIn: (state) => state.loggedIn,
  accessToken: (state) => state.accessToken,
  dict: (state) => state.dict,
  substation: (state) => state.substation,
  webConfig: (state) => state.webConfig,
  open: (state) => state.open,
  shareInfo: (state) => state.shareInfo,
  substationOpened: (state) =>
    Boolean(state.dict.SITE_LIST && state.dict.SITE_LIST.length > 0), // 是否开启分站
  pcMode: (state) => state.pcMode,
  included: (state) => state.included,
  redirectUrl: (state) => state.redirectUrl,
  userType: (state) => state.userType,
  companyInfo: (state) => state.companyInfo,
  isApp: () => device.isApp,
  isIOS: () => device.isIOS,
  captchaConfig: (state) => state.captchaConfig,
  mapSetting: (state) => state.webConfig.map_setting,
};

const actions = {
  logout({ commit }) {
    commit(types.SET_USER_INFO, {});
    commit(types.SET_ACCESS_TOKEN, "");
    commit(types.SET_LOGGED, false);
    commit(types.SET_USER_INFO, {});
    commit(types.SET_COMPANY_INFO, {});
    commit(types.SET_USER_TYPE, null);
    removeToken();
  },
  setIncluded({ commit }, data) {
    commit(types.SET_INCLUDES, data);
  },
  removeIncluded({ commit }) {
    commit(types.REMOVE_INCLUDED);
  },
  setRedirectUrl({ commit }, data) {
    commit(types.SET_REDIRECT_URL, data);
  },
  async loginAction({ commit }, userData) {
    try {
      const res = await Api.handleLogin(userData);
      commit(types.SET_ACCESS_TOKEN, res.token);
      commit(types.SET_LOGGED, true);
      Storage.set("user_type", res.type);
      setToken(res.token);
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async registerAction({ commit }, userData) {
    try {
      const res =
        userData.type === "company"
          ? await Api.companyEnter({ phone: userData.phone })
          : await Api.personEnter({ phone: userData.phone });
      commit(types.SET_ACCESS_TOKEN, res.token);
      commit(types.SET_LOGGED, true);
      Storage.set("user_type", res.type);
      setToken(res.token);
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getWebConfig({ commit }) {
    try {
      const pageConfig = await Api.getWebConfig();
      const res = await Api.getWebConfigs();
      commit(types.SET_WEB_CONFIG, res);
      commit(types.SET_OPEN, res.odd_jobs_application);
      commit(types.SET_SHARE_INFO, pageConfig.baseInfo);
      return Promise.resolve(res);
    } catch (err) {
      return Promise.reject(err);
    }
  },
  async getUserInfo({ commit }) {
    try {
      const res = await Api.getCurrentInfo();

      Storage.set("user_type", res.type);
      if (res.type === 2) {
        const companyInfo = await Api.getCompanyInfo();
        commit(types.SET_COMPANY_INFO, companyInfo);
      }
      // const userInfo = res.type === 1 ? await Api.getPersonInfo() : await Api.getCompanyInfo()
      commit(types.SET_USER_INFO, res);
      commit(types.SET_LOGGED, true);
      commit(types.SET_USER_TYPE, res.type);

      return Promise.resolve(res);
    } catch (err) {
      commit(types.SET_LOGGED, false);
      Storage.set("user_type", 0);
      return Promise.reject(err);
    }
  },
  async getDict({ commit }) {
    try {
      const res = await Api.getDict();
      commit(types.SET_DICT, res);
      try {
        if (res.SITE_LIST && res.SITE_LIST.length > 0) {
          (function () {
            let curr = state.substation;
            if (curr) {
              for (const i of state.dict.SITE_LIST) {
                if (i.id === state.substation) {
                  commit(types.SET_SUBSTATION, i);
                  return;
                }
              }
              // 循环完都没找到
              curr = null; // 重置 交给下一步
            }

            // 取默认
            if (!curr) {
              commit(types.SET_SUBSTATION, res.SITE_LIST[0]);
            }
          })();
        }
      } catch (error) {
        console.log(error);
      }

      return Promise.resolve();
    } catch (err) {
      return Promise.reject();
    }
  },
  async setCaptchaConfig({ commit }) {
    try {
      const res = await Api.getCaptchaConfig({ type: "chuanglan" });
      commit(types.SET_CAPTCHA_CONFIG, res);
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  },
};

const mutations = {
  [types.SET_ACCESS_TOKEN](state, data) {
    state.accessToken = data;
  },
  [types.SET_USER_INFO](state, data) {
    state.userInfo = data;
  },
  [types.SET_DICT](state, data) {
    state.dict = data;
  },
  [types.SET_LOGGED](state, data) {
    state.loggedIn = data;
  },
  [types.SET_SUBSTATION](state, sub) {
    Storage.set("_substation", sub.id || "", 365);
    state.substation = sub.id;
  },
  [types.SET_WEB_CONFIG](state, data) {
    state.webConfig = data;
  },
  [types.SET_SHARE_INFO](state, data) {
    state.shareInfo = data;
  },
  [types.SET_OPEN](state, data) {
    state.open = data;
  },
  [types.SET_INCLUDES](state, data) {
    state.included = ["Home", data];
  },
  [types.REMOVE_INCLUDED](state) {
    state.included = ["Home"];
  },
  [types.SET_REDIRECT_URL](state, data) {
    state.redirectUrl = data;
  },
  [types.SET_USER_TYPE](state, data) {
    state.userType = data;
  },
  [types.SET_COMPANY_INFO](state, data) {
    state.companyInfo = data;
  },
  [types.SET_CAPTCHA_CONFIG](state, data) {
    state.captchaConfig = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
